import { AfterContentChecked, Component,OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../shared/data/data.service';
import { discountCode, discountList, imgList, tourList } from '../shared/models/models';
import { HttpHandler } from '@angular/common/http';
import { categoryList } from '../shared/models/models';


@Component({
  selector: 'app-tour',
  templateUrl: './tour.component.html',
  styleUrls: ['./tour.component.scss']
})
export class TourComponent implements OnInit,AfterContentChecked {

  location: number;
  public TourList: Array<tourList> = [];
  totalTour: number;
  catContent: string='any';
  parentId: string;
  isRun: boolean =false; 
  catType: string;
  title: string='any';
  imageName: string;
  
  public categoryList: Array<categoryList> = [];
  public categoryListSub: Array<categoryList> = [];
  public filterListSub: Array<categoryList> = [];
  public imageList: Array<imgList> = [];
  public discountList: Array<discountCode> = [];


  constructor(private route: ActivatedRoute, public data: DataService, categoryData: DataService) {}


  ngOnInit() {


    this.route.queryParams
      .subscribe(params => {
        console.log(params);
        this.location = params['loc'];
        this.catType = params['type'];
        this.title = params['title'];
        console.log(this.location);
      });

      if (this.title == undefined)
        this.title = 'any';


      this.getTour();
      this.getDiscountCode();
      this.getCategoryListTop();

      if (window.innerWidth <= 576) {
        const mobileMenu = document.querySelector('.aside_header_menu') as HTMLDivElement; 
        mobileMenu.style.display="none";
      }
      
  }


  private getTour() {
    let itinCode='any';
      this.data.getTourByCategory(this.location, this.catType, itinCode ).subscribe((tourdata: any) => {
        //        this.totalCategoryData = categorydata.totalData;
    //               console.log("sub data:", categorydata);
                  this.totalTour = tourdata.length;
                  console.log('totalTour:', this.totalTour);
                  for (let i=0; i<tourdata.length; i++) {
                      this.TourList.push(tourdata[i]);
                      this.catContent=tourdata[i].catContent;
                      this.data.getImageList(tourdata[i].tourCode ).subscribe((tourdata: any) => {
                                  let totalImage = tourdata.length;
                                  console.log('tourImage:', tourdata[0].tourImageName);
                                  this.TourList[i].imageName=tourdata[0].tourImageName;
                              }); 
                      this.data.getTourByCategory(9999, 'sub', tourdata[i].tourCode ).subscribe((selfpaiddata: any) => {
                                  this.TourList[i].selfpaidpdf=selfpaiddata[0].selfpaidpdf;
                      });

                      console.log("return image: ", this.imageName);
            
                  };
              });
      }

      public getImage(tourCode: string): any  {
        console.log('get image: ', tourCode);

      }


      public  setMenuItems() {
        // Setup menu listener, listen click and open submenu 
        const menuItems = document.querySelectorAll(".as_menu_item");
        console.log ("Menu items:", menuItems);
        menuItems.forEach(function (menuItem) {
          menuItem.addEventListener("click", function () {
            menuItem.classList.toggle("active");
        
            var submenu = menuItem.querySelectorAll<HTMLElement>(".as_sub_menu");
            console.log("Sub menu:", submenu);
            if (submenu) {
              submenu[0].style.display = menuItem.classList.contains("active") ? "block" : "none";
            }
        
            menuItems.forEach(function (item) {
              if (item !== menuItem) {
                item.classList.remove("active");
                var otherSubmenu = item.querySelectorAll<HTMLElement>(".as_sub_menu");
                if (otherSubmenu) {
                  otherSubmenu[0].style.display = "none";
                }
              }
            });
          });
        });
  
  
        // If using mobile, hide the widget_title, otherwise show the widget title 
        if (window.innerWidth <= 576) {
          // Footer Widget
          const widgetTitles = document.querySelectorAll<HTMLElement>('.widget_title');
          var index =0, length = widgetTitles.length;
          
          for (; index < length; index++) {
            widgetTitles[index].style.display="none";
          }
            
        } else {
          const widgetTitles = document.querySelectorAll<HTMLElement>('.widget_title');
          var index =0, length = widgetTitles.length;
          
          for (; index < length; index++) {
            widgetTitles[index].style.display="block";
          }
  
        }
        
    }

      private getCategoryListTop() {

        this.data.getCategoryListSub().subscribe((categorydata: any) => {
          //        this.totalCategoryData = categorydata.totalData;
                    console.log("sub data:", categorydata);
                    for (let i=0; i<categorydata.length; i++) {
     //                 console.log("CategoryData:"+categorydata[i]);
     			if(categorydata[i].categoryId !== "187")
                        this.categoryListSub.push(categorydata[i]);
          
              
                    };
                });
          
           
    
          // Get Category List 
          this.data.getCategoryList().subscribe((categorydata: any) => {
    //        this.totalCategoryData = categorydata.totalData;
    
              for (let i=0; i<categorydata.length; i++) {
                console.log("CategoryData:"+categorydata[i]);
		  if(categorydata[i].categoryId !== "186")
                  this.categoryList.push(categorydata[i]);
              };
          });
    
    
    
        }
       

    openPDF(brochureLink: string, type: string ) {
      let checkpdf = brochureLink.split(",");
      let selfpaidlink = "/assets/img/selfpaid/"+brochureLink;

      let pdflink = brochureLink;
      if (checkpdf.length > 1)
        if(checkpdf[0] == ""){
          pdflink = checkpdf[1];
        }else{
          pdflink = checkpdf[0];
        }
      console.log("PDF LINK:",pdflink);
      console.log("Selfpaid LINK:",selfpaidlink);
      if (type == 'S')
        window.open(selfpaidlink, '_blank');
      else {
        let pdffile = pdflink.split("/");
        console.log("PDF file:",pdffile[pdffile.length-1]);
        pdflink = "/download/assets/static/"+pdffile[pdffile.length-1];
        window.open(pdflink, '_blank');
      }
    }

    storeParentId ( item: categoryList ) : boolean {
      this.parentId = item.categoryId;
//      console.log("This parentId:",this.parentId);
  
      this.filterListSub = this.categoryListSub
      .slice()
      .filter(e => e.parentId === this.parentId )
  
      return true;
    }


    ngAfterContentChecked(): void {
      if (!this.isRun) {
        this.setMenuItems();
        const menuItems = document.querySelectorAll(".as_menu_item"); 
        if (menuItems.length > 0) 
          this.isRun= true;
      }
    
    
    }

    loadItineraryPage(tourCode: string): void {
      window.location.href='/itinerary?itinCode='+tourCode;
    }

    showMobileMenu(): void {
      if (window.innerWidth <= 576) {
        const mobileMenu = document.querySelector('.aside_header_menu') as HTMLDivElement; 
        mobileMenu.style.display="block";
      } 
    }

    searchTour() {
      console.log("Search clicked!");
      var searchTour = document.getElementById('searchTour') as HTMLInputElement;
      console.log('searchTour:', searchTour.value);
      window.location.href='tour?loc='+searchTour.value+'&type=search&title='+searchTour.value;
  
    }

    getDiscountCode():any {
      this.data.getDiscountCode().subscribe((discountdata: any) => {
        for (let i=0; i<discountdata.length; i++) {
          this.discountList.push(discountdata[i]);
        }
      });
    }

    discountFilter(tourCode: string):any {  
      let itinCode = tourCode.substring(0.7);
      let discountData = this.discountList.filter(e => e.itinCode === itinCode);
      console.log("discountData:",discountData);
      if (discountData.length > 0) {
        return discountData;
      }
    }
}
